import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";

const name = "getSubjects";
const initialState = createInitialState();

function createInitialState() {
  return {
    done: false,
    error: false,
    spinner: false,
    getSubjects: null,
  };
}

export const getSubjects = createAsyncThunk(
  "getSubjects",
  async (lessonId, rejectWithValue) => {
    try {
      const response = await api.get(`/super/api/subject/get-all/${lessonId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'An error occurred');
    }
  }
);



const getSubjectsSlice = createSlice({
  name: name,
  initialState,
  reducers: {
    resetGetSubjects: (state) => {
      state.done = false;
      state.error = false;
      state.spinner = false;
      state.getSubjects = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSubjects.pending, (state) => {
        state.spinner = true;
        state.error = false;
      })
      .addCase(getSubjects.fulfilled, (state, action) => {
        state.done = true;
        state.spinner = false;
        state.error = false;
        state.getSubjects = action.payload;
      })
      .addCase(getSubjects.rejected, (state, action) => {
        state.done = false;
        state.spinner = false;
        state.error = action.payload;
      });
  },
});

export const { resetGetSubjects } = getSubjectsSlice.actions;
export const getSubjectsReducer = getSubjectsSlice.reducer;
